module.exports = __webpack_public_path__ + "static/img/GN.85e63542.png";